import type { PluginSummary } from '@comficonf/shared';
import { matchPath } from 'react-router';

/** Where the current URL is, as far as the shell's navigation needs to know. */
export interface ShellLocation {
  /** On `/servers/:serverId` and `/servers/:serverId/plugins/:pluginSlug`. */
  serverId: string | undefined;
  /** On the editor route only. */
  pluginSlug: string | undefined;
  /** `?resource=` on the editor route, else null. */
  resource: string | null;
  /** Exactly `/servers/:serverId`. */
  serverPage: boolean;
  /** `/` or any path below `/servers/`. */
  inServers: boolean;
}

export function shellLocation(pathname: string, search: string): ShellLocation {
  const inServers = pathname === '/' || pathname.startsWith('/servers/');
  const editor = matchPath({ path: '/servers/:serverId/plugins/:pluginSlug', end: true }, pathname);
  if (editor) {
    return {
      serverId: editor.params.serverId,
      pluginSlug: editor.params.pluginSlug,
      resource: new URLSearchParams(search).get('resource'),
      serverPage: false,
      inServers,
    };
  }
  const server = matchPath({ path: '/servers/:serverId', end: true }, pathname);
  return {
    serverId: server?.params.serverId,
    pluginSlug: undefined,
    resource: null,
    serverPage: server !== null,
    inServers,
  };
}

/** The settings page the editor shows: the requested one, or the first page when none is requested. */
export function currentResourceId(
  plugin: PluginSummary,
  requested: string | null,
): string | undefined {
  return (
    plugin.resources.find((resource) => resource.id === requested)?.id ??
    (requested === null ? plugin.resources[0]?.id : undefined)
  );
}
